import { defineComponent as _defineComponent } from 'vue'
import CreateTradeModal from 'ah-trades/src/components/modals/CreateTradeModal.vue';
import AddMoneyModal from 'ah-wallets/src/components/AddMoneyModal.vue';
import { AuthorityType, ClientCollateralState } from 'ah-api-gateways';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { computed, reactive } from 'vue';
import { useTradeState } from '../..';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollateralWalletFundActions',
  props: {
    totalEquivalent: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { totalEquivalent: number };



const requestManager = useRequestManager({
  exposeToParent: ['loadWallets'],
  onRetryFromParentManager: (k: string) => {
    if (k === 'loadWallets') {
      loadData();
    }
  },
});

const tradeState = useTradeState();

const onBehalfOfClient = useOnBehalfOf();

const state = reactive<{
  allowedSellCurrencies: string[];
  currencies: string[];
}>({
  allowedSellCurrencies: [],
  currencies: ['GBP', 'EUR', 'USD'],
});

const openTradeAllowed = computed(
  () => onBehalfOfClient.value || tradeState.store.useAuthStore().hasAuthorities(AuthorityType.OPEN_TRADE)
);

const requestPricesAllowed = computed(
  () => onBehalfOfClient.value || tradeState.store.useAuthStore().hasAuthorities(AuthorityType.REQUEST_PRICES)
);

const canSeeFundingDetails = computed(
  () => onBehalfOfClient.value || tradeState.store.useAuthStore().hasAuthorities(AuthorityType.VIEW_FUNDING_DETAILS)
);

const collaterals = computed(() => {
  const clientId = onBehalfOfClient.value
    ? onBehalfOfClient.value.id
    : tradeState.store.useAuthStore().loggedInIdentity?.client?.id;

  if (clientId) {
    return tradeState.store.useWalletsStore().getCollaterals(clientId);
  }
  return null;
});

const notEnoughFunds = computed(
  () => (collaterals.value?.recommendedRecapitalizationAmount ?? 0) > props.totalEquivalent
);

const isBelowUCThreshold = computed(
  () => collaterals.value?.state === ClientCollateralState.ABOVE_RECOMMENDED_RECAP_THRESHOLD
);

const isWithdrawState = computed(() => isBelowUCThreshold.value && (collaterals.value?.unutilizedCollateral ?? 0) > 0);

function loadData() {
  requestManager.manager.newPromise(
    'loadWallets',
    Promise.all(
      state.currencies.map((currency) =>
        tradeState.store.useWalletsStore().loadCurrencyWallet({
          currency,
          owner: onBehalfOfClient.value ? { isPartner: false, id: onBehalfOfClient.value.id } : undefined,
        })
      )
    )
  );

  tradeState.store
    .useSettingsStore()
    .loadTradeableCurrencies()
    .then((currencies) => {
      state.allowedSellCurrencies = currencies
        .map((c) => c.currency)
        .filter((c) => {
          return !['USD', 'EUR', 'GBP'].includes(c);
        });
    });
}

loadData();

return { __sfc: true,props, requestManager, tradeState, onBehalfOfClient, state, openTradeAllowed, requestPricesAllowed, canSeeFundingDetails, collaterals, notEnoughFunds, isBelowUCThreshold, isWithdrawState, loadData, CreateTradeModal, AddMoneyModal }
}

})